import React from 'react';
import {
  Divider,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BookIcon from '@mui/icons-material/Book';
import ComputerIcon from '@mui/icons-material/Computer';
import AppsIcon from '@mui/icons-material/Apps';
import HubIcon from '@mui/icons-material/Hub';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ShieldIcon from '@mui/icons-material/Shield';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import StorageIcon from '@mui/icons-material/Storage';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FolderIcon from '@mui/icons-material/Folder';
import MemoryIcon from '@mui/icons-material/Memory';
import GroupIcon from '@mui/icons-material/Group';
import ArchiveIcon from '@mui/icons-material/Archive';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link } from 'react-router';
import JOB_TYPES from '@/components/jobs/types';
import { useUser, useAuth } from '@/providers';

function SidebarContent({ toggleDrawer }) {
  const user = useUser();
  const session = useAuth();

  const iconMap = {
    book: BookIcon,
    server: ComputerIcon,
    cubes: AppsIcon,
    sitemap: HubIcon,
    psychology: PsychologyIcon,
    shield: ShieldIcon,
  };

  if (!session || !session.isLoggedIn || !user || user.status !== 'approved') {
    return null;
  }

  return (
    <>
      <List component='nav'>
        <ListItemButton component={Link} to='/dashboard' onClick={toggleDrawer}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary='Home' />
        </ListItemButton>
      </List>
      <Divider sx={{ my: 1 }} />
      <List component='nav'>
        {Object.entries(JOB_TYPES).map(([key, type]) => {
          const IconComponent = iconMap[type.icon] || BookIcon;
          return (
            <ListItemButton
              key={type.value}
              component={Link}
              to={`/jobs/${type.value}`}
              onClick={toggleDrawer}
            >
              <ListItemIcon>
                <IconComponent />
              </ListItemIcon>
              <ListItemText primary={type.label} />
            </ListItemButton>
          );
        })}
        <ListItemButton
          component={Link}
          to='/checkpoint'
          onClick={toggleDrawer}
        >
          <ListItemIcon>
            <CheckBoxIcon />
          </ListItemIcon>
          <ListItemText primary='Checkpoints' />
        </ListItemButton>
        <ListItemButton component={Link} to='/dataset' onClick={toggleDrawer}>
          <ListItemIcon>
            <StorageIcon />
          </ListItemIcon>
          <ListItemText primary='Datasets' />
        </ListItemButton>
        <ListItemButton component={Link} to='/model' onClick={toggleDrawer}>
          <ListItemIcon>
            <AccountTreeIcon />
          </ListItemIcon>
          <ListItemText primary='Models' />
        </ListItemButton>
        <ListItemButton component={Link} to='/volume' onClick={toggleDrawer}>
          <ListItemIcon>
            <FolderIcon />
          </ListItemIcon>
          <ListItemText primary='Volumes' />
        </ListItemButton>
      </List>
      <Divider sx={{ my: 1 }} />
      <List component='nav'>
        <ListItemButton component={Link} to='/resources' onClick={toggleDrawer}>
          <ListItemIcon>
            <MemoryIcon />
          </ListItemIcon>
          <ListItemText primary='CloudBender®' />
        </ListItemButton>
        <ListItemButton component={Link} to='/projects' onClick={toggleDrawer}>
          <ListItemIcon>
            <GroupIcon />
          </ListItemIcon>
          <ListItemText primary='Projects' />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to='/archive/jobs'
          onClick={toggleDrawer}
        >
          <ListItemIcon>
            <ArchiveIcon />
          </ListItemIcon>
          <ListItemText primary='Archive' />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to='/account/billing'
          onClick={toggleDrawer}
        >
          <ListItemIcon>
            <PaymentIcon />
          </ListItemIcon>
          <ListItemText primary='Billing' />
        </ListItemButton>
        <ListItemButton
          component={Link}
          to='/account/settings'
          onClick={toggleDrawer}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary='Settings' />
        </ListItemButton>
      </List>
    </>
  );
}

export default SidebarContent;
